import { get, post, put } from 'services/api';
import { increaseLoading, decreaseLoading } from './loading';
import { hjTagging } from 'utils';

const receiveRating = (rating: any) => ({
  type: 'RECEIVE_RATING',
  rating,
});

export const sendRating = (lessonID: any, rating: any) => (dispatch: Function) => {
  dispatch(receiveRating(rating));

  dispatch(increaseLoading());

  const data = {
    rating: rating.user_rating,
  };

  return post({ url: `/learner/lessons/${lessonID}/ratings`, data }).then(
    () => {
      hjTagging('FEZ-AVALIACAO');
      dispatch(decreaseLoading());
    },
    () => {
      dispatch(decreaseLoading());
    }
  );
};

export const refreshRating = (lessonID: any, rating: any) => (dispatch: Function) => {
  dispatch(receiveRating(rating));

  dispatch(increaseLoading());

  const data = {
    rating: rating.user_rating,
  };

  return put({ url: `/learner/lessons/${lessonID}/ratings`, data }).then(
    () => {
      dispatch(decreaseLoading());
    },
    () => {
      dispatch(decreaseLoading());
    }
  );
};

export const fetchRating = (lessonID: any) => (dispatch: Function) => {
  if (!lessonID) return false;
  return get({ url: `/learner/lessons/${lessonID}/ratings`, validateStatus: () => true }).then((res) => {
    dispatch(receiveRating(res.data.data || {}));

    return res.data;
  });
};
